module.exports = __webpack_public_path__ + "static/media/b-flecha.6f9b127e.webp";